import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import config from "../config";
import { postApi,baseURL} from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';
import { message } from "antd";


class InventoryReportStore {
  InventoryReport=[]
  warehouseArray = []
  inventoryArray = []
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      InventoryReport: observable,
      warehouseArray: observable,
      inventoryArray: observable,
      total:observable,
      loading:observable,
      loadData:action,
      getWarehouseByCompanyId:action,
      getInventoryByCompanyId:action,
      exportExcel:action,
      exportpdf:action,
      exportcsv:action,
      exportxml:action
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,fromDate,toDate,warehouseId,inventoryId}) {
    this.loading=true;
    var postData = {"companyId":companyId,"warehouseId":warehouseId,"inventoryId":inventoryId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":1}
    console.log("Inventory Report")
    if(config.pythonReport == 1){
        var response = await postApi.getClient('report').post("/miscellaneous_report/InventoryStatusReport", postData);
    }
   
    this.InventoryReport =response?.data?.data?.inventorystatusdata
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;

  }

  async getWarehouseByCompanyId({companyId}){
    this.loading = true;
    console.log("getWarehouseByCompanyId")

    var postData ={companyId:companyId}
    var response = await postApi.getClient().post(config.NodeUrl +"/inventory/warehousebycompanyId", postData);
    console.log("warehouse" ,response.data.data)
    this.warehouseArray = response?.data?.data

    this.loading=false;
  }
   
  async getInventoryByCompanyId({companyId,warehouseId}){
    console.log("getInventoryByCompanyId")

    var postData ={companyId:companyId,warehouseId:warehouseId}
    
    var response = await postApi.getClient().post(config.NodeUrl +"/inventory/inventorybycompanyId", postData);
    console.log("inventory" ,response.data.data)
    this.inventoryArray = response?.data?.data

    this.loading=false;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport === 1) {
        try {
          var response = await postApi.getClient("report").post("/miscellaneous_report/InventoryStatusReport/download/excel", getData, {
            responseType: "blob",
          });
           const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Inventory Status Report.xlsx";
    
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
    } catch (error) {
        message.error("Failed to download the report. Please try again.")
    }
        //   this.pythonReportMessage = true;
        // } catch (error) {
        //   this.pythonReportErrorMessage = true;
        // }
    
    }
  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {
      
      try {
          var response = await postApi.getClient("report").post("/miscellaneous_report/InventoryStatusReport/download/pdf", getData, {
            responseType: "blob",
          });
           const blob = new Blob([response.data], {
                type: 'application/pdf'
            });
        
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Inventory Status Report.pdf";
        
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
    } catch (error) {
        message.error("Failed to download the report. Please try again.")
    }
    //     this.pythonReportMessage = true;
    //   } catch (error) {
    //     this.pythonReportErrorMessage = true;
    //   }
    }else{
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exporteventpdf&cid=" +
        getData.companyId +
        "&vid=" +
        getData.vehicleId +
        "&eventCode=" +
        getData.eventCode +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventcsv&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exporteventxml&cid=" +
      getData.companyId +
      "&vid=" +
      getData.vehicleId +
      "&eventCode=" +
      getData.eventCode +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  
  


}

export default InventoryReportStore;
